import {
  Card, Row, Col, Space, Typography, Button, Divider, Form, Input, Modal
} from "antd";
import { LeftCircleOutlined, EditOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import Answers from "../../components/Answers/answers";
import useAppointmentEdit from "./useAppointmentEdit";

const { Title, Text } = Typography;

const AppointmentEdit = () => {
  const { t } = useTranslation();
  const {
    appointment,
    navigate,
    modalOpen,
    toggleModal,
    onSubmit,
    loading,
    form
  } = useAppointmentEdit();

  if (appointment) {
    return (
      <>
        <Row gutter={[24, 24]}>
          <Col xl={17} span={24}>
            <Space direction="vertical" size={16} style={{ width: "100%", marginBottom: 16 }}>
              <Button type="link" onClick={() => navigate(-1)} style={{ paddingLeft: 0, paddingRight: 0 }}>
                <Space size="small"><LeftCircleOutlined style={{ color: "#000000", opacity: "0.45" }} />
                  <Text type="secondary">{t("global.button.goBack")}</Text>
                </Space>
              </Button>
              <Divider style={{ margin: 0 }}/>
            </Space>
          </Col>
        </Row>
        <Row gutter={[24, 24]}>
          <Col xl={17} span={24}>
            <Space direction="vertical" size={16}>
              <Title level={3} style={{ marginBottom: 0, lineHeight: 1 }}>
                {t("appointment.delete.title")}
              </Title>
              <Text type="secondary">
                {t("appointment.delete.text")}
              </Text>
              <Form
                name="edit-appointment"
                layout="vertical"
                variant="filled"
                onFinish={toggleModal}
                form={form}
                autoComplete="off"
                style={{ maxWidth: 380 }}
              >
                <Form.Item
                  label={<Text strong style={{ fontSize: 16 }}>{t("form.label.motivation")}</Text>}
                  name="motivation"
                  tooltip="test"
                  rules={[{ required: true, message: t("form.error.motivation") }]}
                  style={{ marginBottom: 16 }}
                >
                  <Input placeholder="Inserisci una motivazione" suffix={<EditOutlined style={{ color: "#00000026" }}/>} />
                </Form.Item>

                <Form.Item>
                  <Button danger htmlType="submit" disabled={loading} loading={loading}>
                    {t("appointment.delete.submitButton")}
                  </Button>
                </Form.Item>
              </Form>
            </Space>
          </Col>
          <Col xl={7} span={24}>
            <Space size={24} direction="vertical" style={{ width: "100%" }}>
              <Card>
                <Space size={16} direction="vertical" style={{ width: "100%" }}>
                  <Title level={4} style={{ marginBottom: 0 }}>
                    {appointment.patient?.name} {appointment.patient?.surname}
                  </Title>
                  <Text type="secondary" style={{ fontSize: 18 }}>
                    {`Paziente iscritto dal ${
                      dayjs(appointment.patient?.created_at).format("DD MMMM YYYY")
                    }`}
                  </Text>
                  <Text>
                    <Answers patientId={appointment.patient?.id} />
                  </Text>
                </Space>
              </Card>
            </Space>
          </Col>
        </Row>
        <Modal
          title={`${t("appointment.delete.confirmation")}?`}
          open={modalOpen}
          onOk={onSubmit}
          onCancel={toggleModal}
          okText={t("global.button.yes")}
          cancelText={t("global.button.cancel")}
        />
      </>
    );
  }
  return <>There is no active appointments</>;
};

export default AppointmentEdit;
